"use client";

import React from "react";
import Image from "next/image";
import { teamMembers } from "./team-data";

export default function TeamSectionMobile() {
  return (
    <section className="bg-black py-[60px]">
      <div className="max-w-[640px] mx-auto px-4 flex flex-col gap-[40px]">
        <div className="flex flex-col gap-[20px] text-center">
          <p className="text-white text-[14px] uppercase tracking-[0.2em]">
            Teams
          </p>
          <h2 className="text-white text-[clamp(2rem,6vw,2.75rem)] leading-[120%] clash-font font-medium">
            Meet Our Team of Lateral Thinkers.
          </h2>
          <p className="text-white/70 text-[17px] leading-[150%]">
            Konstant leaders nurture every team member to uncover their calling,
            driving a culture of innovation and collaboration.
          </p>
        </div>

        <div className="flex flex-col gap-[40px]">
          {teamMembers?.map((member, index) => (
            <article
              key={member.id}
              className="flex flex-col gap-[20px] border border-white/10 bg-white/[0.03] rounded-[24px] overflow-hidden"
            >
              <div className="relative w-full aspect-[328/360] bg-black/20">
                <Image
                  src={member.image}
                  alt={member.name}
                  fill
                  className="object-cover"
                  sizes="(max-width: 768px) 100vw, 50vw"
                />
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute top-0 left-0 w-[12px] h-[12px] border-t border-l border-[#225BD4]" />
                  <div className="absolute top-0 right-0 w-[12px] h-[12px] border-t border-r border-[#225BD4]" />
                  <div className="absolute bottom-0 left-0 w-[12px] h-[12px] border-b border-l border-[#225BD4]" />
                  <div className="absolute bottom-0 right-0 w-[12px] h-[12px] border-b border-r border-[#225BD4]" />
                </div>
                {member.linkedIn && (
                  <div className="absolute top-[15px] right-[15px]">
                    <a
                      href={member.linkedIn}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[40px] h-[40px] bg-[#225BD4] rounded-[5px] flex items-center justify-center hover:bg-[#1a4aa8] transition-colors"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                      </svg>
                    </a>
                  </div>
                )}
              </div>

              <div className="flex flex-col gap-[16px] px-[24px] pb-[28px] text-center">
                <div className="flex flex-col gap-[8px]">
                  <span className="text-white/40 text-[13px] tracking-[0.3em] uppercase">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h3 className="text-white text-[30px] leading-[120%] clash-font font-medium">
                    {member.name}
                  </h3>
                  <div className="mx-auto bg-white/[0.08] border border-white/10 rounded-[50px] px-[18px] py-[6px] whitespace-nowrap">
                    <span className="text-white text-[14px] leading-[140%]">
                      {member.position}
                    </span>
                  </div>
                </div>

                {member.quote && (
                  <p className="text-white text-[18px] leading-[150%] font-semibold italic">
                    “{member.quote}”
                  </p>
                )}
                {member.description && (
                  <p className="text-[#949596] text-[17px] leading-[150%]">
                    {member.description}
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
